var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.body)?_c('DsfrBadge',{attrs:{"mode":_vm.mode}},[_c('p',{staticClass:"ma-0 pa-0 text-uppercase"},[_vm._v(_vm._s(_vm.body))])]):_c('span')}
var staticRenderFns = []

export { render, staticRenderFns }